module.exports = __webpack_public_path__ + "static/media/sz.dccfae47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sz.png
// module id = 1991
// module chunks = 0